'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_webclient\uff3fprelude_prelude_laminar$package$() {
  this.aYp = null;
  this.aYq = false;
}
export { $c_Lapp_webclient\uff3fprelude_prelude_laminar$package$ as $c_Lapp_webclient\uff3fprelude_prelude_laminar$package$ };
$p = $c_Lapp_webclient\uff3fprelude_prelude_laminar$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_webclient\uff3fprelude_prelude_laminar$package$;
/** @constructor */
function $h_Lapp_webclient\uff3fprelude_prelude_laminar$package$() {
}
export { $h_Lapp_webclient\uff3fprelude_prelude_laminar$package$ as $h_Lapp_webclient\uff3fprelude_prelude_laminar$package$ };
$h_Lapp_webclient\uff3fprelude_prelude_laminar$package$.prototype = $p;
$p.Ea = (function() {
  if ((!this.aYq)) {
    this.aYp = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((value) => value.dq.bwI())), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.aYq = true;
  }
  return this.aYp;
});
var $d_Lapp_webclient\uff3fprelude_prelude_laminar$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_webclient\uff3fprelude_prelude_laminar$package$, "app.webclient_prelude.prelude.laminar$package$", ({
  ID: 1
}));
export { $d_Lapp_webclient\uff3fprelude_prelude_laminar$package$ as $d_Lapp_webclient\uff3fprelude_prelude_laminar$package$ };
var $n_Lapp_webclient\uff3fprelude_prelude_laminar$package$;
function $m_Lapp_webclient\uff3fprelude_prelude_laminar$package$() {
  if ((!$n_Lapp_webclient\uff3fprelude_prelude_laminar$package$)) {
    $n_Lapp_webclient\uff3fprelude_prelude_laminar$package$ = new $c_Lapp_webclient\uff3fprelude_prelude_laminar$package$();
  }
  return $n_Lapp_webclient\uff3fprelude_prelude_laminar$package$;
}
export { $m_Lapp_webclient\uff3fprelude_prelude_laminar$package$ as $m_Lapp_webclient\uff3fprelude_prelude_laminar$package$ };
//# sourceMappingURL=app.webclient_prelude.prelude.laminar$package$.js.map
